import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface Props {
  inlineDefaultActions: boolean
  disableExport: boolean
  exportIsAvailable: boolean
  disableEditColumns?: boolean
  customPopoverOptions?: React.ReactNode
  onExportClick: () => void
  onEditColumnsClick: () => void
  disableDefaultActions: boolean
}

const Actions = ({
  inlineDefaultActions,
  customPopoverOptions,
  exportIsAvailable,
  disableExport,
  disableEditColumns,
  disableDefaultActions,
  onExportClick,
  onEditColumnsClick,
}: Props) => {
  const exportEnabled = !disableExport && exportIsAvailable
  const editColumnsEnabled = !disableEditColumns

  const popoverOptions = [
    exportEnabled && !inlineDefaultActions && (
      <PopoverMenu.TouchableOption
        key="export"
        title={i18n.t('data_table.export.main')}
        description={i18n.t('data_table.export.description')}
        onClick={onExportClick}
      />
    ),
    !!customPopoverOptions && <React.Fragment key="custom">{customPopoverOptions}</React.Fragment>,
    editColumnsEnabled && !inlineDefaultActions && (
      <PopoverMenu.TouchableOption
        key="edit"
        title={i18n.t('data_table.edit_columns.main')}
        onClick={onEditColumnsClick}
      />
    ),
  ].filter(Boolean)

  if (disableDefaultActions && popoverOptions.length > 0) return <></>

  return (
    <>
      <Box flexDirection="row" gap="s8">
        {exportEnabled && inlineDefaultActions && (
          <Button
            type="secondary"
            title={i18n.t('data_table.export.main')}
            iconName="download"
            onClick={onExportClick}
          />
        )}
        {editColumnsEnabled && inlineDefaultActions && (
          <Button
            type="secondary"
            title={i18n.t('data_table.edit_columns.main')}
            iconName="list"
            onClick={onEditColumnsClick}
          />
        )}
      </Box>
      {popoverOptions.length > 0 && (
        <PopoverMenu type="list">
          <PopoverMenu.Trigger>
            <Button.Decorative type="secondary" iconName="ellipsis" />
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="end">
            {popoverOptions}
          </PopoverMenu.Content>
        </PopoverMenu>
      )}
    </>
  )
}

export default Actions
